import { createApp } from 'vue'
import StafetDeltagPaaHoldStepFour from './StafetDeltagPaaHoldStepFour'

const el = '.kb-component--stafet-join-a-team-step-four'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagPaaHoldStepFourDOM) => {
            const component = createApp(StafetDeltagPaaHoldStepFour).use(Store)
            component.mount(StafetDeltagPaaHoldStepFourDOM)
        })
    }
}
